import type { AxiosInstance } from 'axios';
import type {
  CreateMessageGenSessionRequest,
  MessageGenSession,
  MessageGenSessionEventRequest,
  MarketingMessage,
} from '../types/message-generation.js';
import type { Chat } from '../types/chat.js';

export class MessageGenerationClient {
  constructor(private authenticatedClient: AxiosInstance) {}

  createSession = async (data: CreateMessageGenSessionRequest): Promise<MessageGenSession> => {
    const res = await this.authenticatedClient.post<MessageGenSession>('/message-gen-sessions', data);
    return res.data;
  };

  getSession = async (sessionId: string): Promise<MessageGenSession> => {
    const res = await this.authenticatedClient.get<MessageGenSession>(`/message-gen-sessions/${sessionId}`);
    return res.data;
  };

  sendEvent = async (data: MessageGenSessionEventRequest): Promise<void> => {
    await this.authenticatedClient.post('/message-gen-sessions/events', data);
  };

  startSession = async (
    source: 'segment' | 'files' | 'generic',
    config: {
      segmentIdentifier?: string;
      count: number;
      category: string;
      targetAudience: string;
    }
  ): Promise<{ sessionId: string; chatInstanceId: string }> => {
    const res = await this.authenticatedClient.post<{ sessionId: string; chatInstanceId: string }>(
      '/message-gen-sessions/start',
      { source, config }
    );
    return res.data;
  };

  listMessages = async (sessionId: string): Promise<Chat.Query[]> => {
    const res = await this.authenticatedClient.get<Chat.Query[]>(`/message-gen-sessions/${sessionId}/messages`);
    return res.data;
  };

  updateMessage = async (
    sessionId: string,
    messageId: string,
    updates: Partial<MarketingMessage>
  ): Promise<Chat.Query> => {
    const res = await this.authenticatedClient.patch<Chat.Query>(
      `/message-gen-sessions/${sessionId}/messages/${messageId}`,
      updates
    );
    return res.data;
  };
}
